// extracted by mini-css-extract-plugin
export var chip = "_mf-0";
export var icon = "_mf-1";
export var remove = "_mf-2";
export var removeIcon = "_mf-3";